import { Drawer } from '@grupoboticario/flora-react';
import Cookies from 'js-cookie';
import { useLocation } from 'react-router-dom';

import { FloraProvider } from 'containers/ProviderComposer/providers';
import { drawerTitle, portugueseCadastralChangeName } from 'helpers';
import { useResellerRegistration, useTracking } from 'hooks';
import { ACCESS_TOKEN_KEY_CADASTRAL_CHANGE } from 'services/auth';

import { getStep } from './helpers';
import { HeaderContent } from '../components';
import Styles from '../Drawers.styles';

type CadastralChangeParams = {
  type: string;
  children: JSX.Element;
};

export const CadastralChange = ({ type, children }: CadastralChangeParams) => {
  const location = useLocation();
  const { isError } = useResellerRegistration();
  const { sendDataToGTM } = useTracking();

  const step = getStep(type, location.pathname);

  const closeDrawerChange = () => {
    Cookies.remove(ACCESS_TOKEN_KEY_CADASTRAL_CHANGE);
    window.location.replace('/perfil');
  };

  const handleDrawer = () => {
    sendDataToGTM({
      event: 'analytics-event', // always this event name
      event_parameters: {
        event_name: `interaction_alterar_${portugueseCadastralChangeName[type]}`,
        cd_interaction_detail: 'click:fechar-drawer',
      },
    });
  };

  if (!type || !step || isError) {
    return null;
  }

  return (
    <Drawer
      open={true}
      onOpenChange={closeDrawerChange}
      data-autotagging-flora-section={`alterar_${portugueseCadastralChangeName[type]}`}
    >
      <Styles.DrawerContent side='right'>
        <FloraProvider>
          <Styles.DrawerHeader>
            <HeaderContent
              title={drawerTitle[type]}
              isToBack={false}
              onCloseCallback={handleDrawer}
            />
          </Styles.DrawerHeader>
          <Styles.DrawerBody>{children}</Styles.DrawerBody>
        </FloraProvider>
      </Styles.DrawerContent>
    </Drawer>
  );
};
export default CadastralChange;
